import { render } from "./TheResetPassword.vue?vue&type=template&id=cc3a8a86&ts=true"
import script from "./TheResetPassword.vue?vue&type=script&lang=ts"
export * from "./TheResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__